module.exports = __webpack_public_path__ + "static/media/logo_2020_no_text.2fb2b813.svg";